module.exports = __webpack_public_path__ + "static/media/2_Nic_P@3x.5733bdb0.jpg";